export const routes = {
  privacy: "/privacy",
  imprint: "/imprint",
  questionnaire: {
    base: "/",
    personalInformation: "/personal-information",
    jawQuestion: "/jaw-question",
    body: {
      complaintsMapIntro: "/body/complaints-map-intro",
      complaintsMap: "/body/complaints-map",
    },
    jaw: {
      complaintsMapIntro: "/jaw/complaints-map-intro",
      complaintsMap: "/jaw/complaints-map",
    },
    almostDone: "/almost-done",
    cancelAppointment: "/cancel-appointment",
    additionalPayment: "/additional-payment",
    info: "/info",
    send: "/send",
    done: "/done",
  },
} as const;
